import * as React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export const PAGE_SIZE_OPTIONS = [20, 50, 100, 250, 500];
export const DEFAULT_PAGE_SIZE = 20;

interface PageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  className?: string;
  disabled?: boolean;
}

/**
 * Shared "Rows per page" selector used by the Contacts, Sessions, and Visitors
 * tables so pagination controls look and behave the same everywhere.
 */
const PageSizeSelect: React.FC<PageSizeSelectProps> = ({
  value,
  onChange,
  options = PAGE_SIZE_OPTIONS,
  className,
  disabled,
}) => (
  <div className={`flex items-center gap-2 ${className || ''}`}>
    <span className="text-sm text-muted-foreground whitespace-nowrap">Rows per page</span>
    <Select
      value={String(value)}
      onValueChange={(v) => onChange(Number(v))}
      disabled={disabled}
    >
      <SelectTrigger className="w-[84px] h-9">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt} value={String(opt)}>
            {opt}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default PageSizeSelect;
